import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

const BSE_UAT_OPERATOR_PATHS = new Set([
  "/admin/bse2",
  "/admin/bse2/uat-dossier",
  "/admin/bse2/workbench",
  "/admin/ucc-onboarding",
  "/admin/bse-reconciliation",
  "/admin/orders",
  "/admin/redemptions",
  "/admin/switches",
  "/admin/sips",
  "/admin/mandates",
  "/admin/payments",
]);

export function AdminProtectedRoute({ children }) {
  const { admin, loading } = useAdminAuth();
  const location = useLocation();
  if (loading) return null;
  if (!admin) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  if (admin.role === "bse_uat_operator" && !BSE_UAT_OPERATOR_PATHS.has(location.pathname)) {
    return <Navigate to="/admin/bse2" replace />;
  }
  return children;
}
